import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFileRemoveComponent } from "./med-icon-file-remove.component";

@NgModule({
  declarations: [
    MedIconFileRemoveComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFileRemoveComponent,
  ],
})
export class MedIconFileRemoveModule { }
